<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-full"
    title="確認"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container fluid>
                <div class="font-weight-bold mb-3">
                  インターネットType4を削除します。よろしいですか？
                </div>
                <!--  インターネットType4        -->
                <v-row>
                  <v-col>
                    <h3>インターネットType4</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col cols="4">
                    <app-label-group
                      label="VPN/VNコード"
                      :value="
                        selectedItem.vpnVnCode.charAt(0) !== 'B'
                          ? `${selectedItem.vpnVnCode}(${selectedItem.vnName})`
                          : selectedItem.vpnVnCode
                      "
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="回線番号(メイン)"
                      :value="`${selectedItem.wnumberMainAct}/${selectedItem.wnumberMainSby}[${$filter.enumTo(selectedItem.mainSite, 'mainSite')}]`"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="回線番号(BCP)"
                      :value="`${selectedItem.wnumberBcpAct}/${selectedItem.wnumberBcpSby}[${$filter.enumTo(selectedItem.mainSite === 'TOKYO' ? 'OSAKA' : 'TOKYO', 'mainSite')}]`"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group label="Type" value="インターネットType4" />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="Type4ID"
                      :value="selectedItem.type4Id"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="Type4名"
                      :value="selectedItem.type4Name"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="メインサイト"
                      :value="$filter.enumTo(selectedItem.mainSite, 'mainSite')"
                    />
                  </v-col>
                </v-row>
                <!--  アプライアンス        -->
                <v-row>
                  <v-col>
                    <h3>アプライアンス</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col cols="4">
                    <app-label-group label="セキュリティアプライアンス">
                      <template #value>
                        <span class="ml-3">
                          <template v-if="selectedItem.applianceType === 'IFW'">
                            インターネットFW(100Mbpsベストエフォート)
                          </template>
                          <template
                            v-if="
                              selectedItem.applianceType === 'UTM' &&
                              selectedItem.contractType === 'BEST_EFFORT'
                            "
                          >
                            UTM(1Gbpsベストエフォート)
                          </template>
                          <template
                            v-if="
                              selectedItem.applianceType === 'UTM' &&
                              selectedItem.contractType === 'SECURING'
                            "
                          >
                            UTM(帯域確保型{{ selectedItem.bandwidth!.value
                            }}{{
                              $filter.enumTo(
                                selectedItem.bandwidth!.unit,
                                "bandwidth_unit"
                              )
                            }})
                          </template>
                        </span>
                      </template>
                    </app-label-group>
                  </v-col>
                  <v-col cols="4" v-if="user.contractSummary.isSecuritySetting">
                    <app-label-group
                      label="セキュリティ監視オプション"
                      :value="
                        $filter.enumTo(selectedItem.isSecurityOption, 'on_off')
                      "
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group label="インターネット帯域">
                      <template #value>
                        <span class="ml-3">
                          <template v-if="selectedItem.applianceType === 'IFW'">
                            100Mbpsベストエフォート
                          </template>
                          <template
                            v-if="
                              selectedItem.applianceType === 'UTM' &&
                              selectedItem.contractType === 'BEST_EFFORT'
                            "
                          >
                            1Gbpsベストエフォート
                          </template>
                          <template
                            v-if="
                              selectedItem.applianceType === 'UTM' &&
                              selectedItem.contractType === 'SECURING'
                            "
                          >
                            帯域確保型
                            {{ selectedItem.bandwidth!.value
                            }}{{
                              $filter.enumTo(
                                selectedItem.bandwidth!.unit,
                                "bandwidth_unit"
                              )
                            }}
                          </template>
                        </span>
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--  オプション        -->
                <v-row>
                  <v-col>
                    <h3>オプション</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col cols="4">
                    <app-label-group
                      label="追加グローバルIP数"
                      :value="`${selectedItem.globalIpAddressList.length - 1}個`"
                    >
                    </app-label-group>
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="M365経路制御オプション"
                      :value="
                        $filter.enumTo(selectedItem.isMicrosoft365, 'on_off')
                      "
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="状態"
                      :value="$filter.enumTo(selectedItem.status, 'status')"
                    />
                  </v-col>
                </v-row>
                <!--  契約情報        -->
                <v-row>
                  <v-col>
                    <h3>契約情報</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col cols="4">
                    <app-label-group
                      label="契約者名"
                      :value="
                        $filter.emptyTo(
                          selectedItem.contractInfo.contractor,
                          '-'
                        )
                      "
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="メールアドレス"
                      :value="selectedItem.contractInfo.email"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="エンドユーザ名"
                      :value="selectedItem.contractInfo.endUserName"
                    />
                  </v-col>
                </v-row>
                <!--  保守連絡先情報        -->
                <v-row>
                  <v-col>
                    <h3>保守連絡先情報</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <template v-if="selectedItem.maintenance">
                    <v-col cols="4">
                      <app-label-group
                        label="会社名"
                        :value="selectedItem.maintenance.company"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="部署名"
                        :value="selectedItem.maintenance.department"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="担当者名"
                        :value="selectedItem.maintenance.name"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="電話番号"
                        :value="selectedItem.maintenance.phone"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="メールアドレス"
                        :value="selectedItem.maintenance.email"
                      />
                    </v-col>
                  </template>
                  <v-col cols="4" v-else> - </v-col>
                </v-row>
                <v-row>
                  <!-- prettier-ignore  -->
                  <v-col>
                    <!-- eslint-disable-next-line vue/no-mutating-props -->
                    <validation-provider name="note" v-model="putItem.note"
                                         label="オーダー備考"
                                         :rules="{ max: { length: 200 } }"
                                         v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-badge
                          item="オーダー備考"
                          :msg="
                        $filter.message('info_max_length', {
                          maxLength: '200',
                        })
                      "
                          :isRequired="false"
                          placement="end"
                      />
                      <app-form-input
                          v-bind="componentField"
                          :error-messages="errorMessage"
                          :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <div class="d-flex justify-center">
                  <v-checkbox
                    hide-details
                    v-model="accepted"
                    label="契約(料金変更)に関わる操作を実施します。"
                  ></v-checkbox>
                </div>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn
                  type="submit"
                  variant="flat"
                  color="primary"
                  :disabled="!accepted"
                  >はい
                </v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel"
                  >いいえ
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type {
  Type4Service,
  Type4ServiceDeletePostRequest,
} from "@/apis/ContractChangeType4Api";
import { VueFinalModal } from "vue-final-modal";
import AppLabelGroup from "@/components/AppLabelGroup.vue";

export default defineComponent({
  name: "InternetType4ContractDeleteConfirm",
  components: { AppLabelGroup },
  props: {
    selectedItem: {
      type: Object as PropType<Type4Service>,
      required: true,
    },
    putItem: {
      type: Object as PropType<Type4ServiceDeletePostRequest>,
      required: true,
    },
  },
  data() {
    return {
      accepted: false,
      user: this.$store.state.user,
    };
  },
  methods: {
    /** 「はい」選択時の挙動 */
    submit() {
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
